import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import { useOperationsItem } from "./useItems";
import getThemeColor, {
  getThemePrimary50Color,
} from "../../../Utils/getThemeColor";
import { SUBMENU } from "../data/contants";
import OperationsIcon from "../../../Common/Svgs/OperationsIcon";

const OperationItem = ({
  sidebarActive,
  pageName,
  subMenu,
  setSubMenu,
  // setSidebarActive,
}) => {
  const navigate = useNavigate();

  const { theme } = useSelector((state) => state.loggedInUser);

  const [hover, setHover] = useState(false);

  // sub menu items
  const items = useOperationsItem().filter((item) => item.hasPermission);

  const activeItem =
    window.location.pathname.includes("trips") ||
    window.location.pathname.includes("sessions") ||
    window.location.pathname.includes("rentals")
      ? 1
      : -1;

  const handleSubMenu = () => {
    if (subMenu === SUBMENU.OPERATIONS) {
      setSubMenu(SUBMENU.DEFAULT);
    } else {
      setSubMenu(SUBMENU.OPERATIONS);
    }
    // setSidebarActive(true);
    // if (subMenu === SUBMENU.OPERATIONS) {
    //   setSubMenu(SUBMENU.DEFAULT);
    // } else {
    // setSubMenu(SUBMENU.OPERATIONS);
    // }
  };

  const getContainerStyle = () => {
    // sidebar is closed
    if (!sidebarActive) {
      // if operations submenu is open
      if (subMenu === SUBMENU.OPERATIONS) {
        return "w-[231px] bg-primary rounded-t-md";
      }

      // if hovering
      if (hover) {
        return "w-[160px] bg-primary rounded-md";
      }
    }

    // sidebar is open
    if (sidebarActive) return "bg-primary-50";

    // default
    return "w-full";
  };

  const getHeaderMenuStyle = () => {
    // sidebar is closed
    if (!sidebarActive) {
      // if hovering over the menu item or the submenu is open
      if (hover || subMenu === SUBMENU.OPERATIONS) {
        return "ml-2 text-sidebar-active stroke-sidebar-active";
      }
    }

    if (activeItem > -1 || subMenu === SUBMENU.OPERATIONS) {
      return "text-sidebar-active stroke-sidebar-active";
    }

    return "text-sidebar-base stroke-sidebar-base";
  };

  const getHeaderIconStyle = () => {
    // if the current page is part of the submenu the fill the header icon
    if (activeItem > -1) {
      return theme === "green-theme" ? "#fad152" : "#fff";
    }

    // if the sidebar is closed then fill color will be the theme color
    if (!sidebarActive) {
      return getThemeColor(theme);
    }

    // if none of the conditions are true then return the bgColor of the Header item (transparent-white)
    return getThemePrimary50Color(theme);
  };

  // container of the submenu
  const getSubMenuContainerStyle = () => {
    if (!sidebarActive && subMenu === SUBMENU.OPERATIONS) {
      return "absolute ml-[71px] w-[160px] bg-primary border-t-[0.5px] border-l border-white rounded-br-md";
    }

    return "";
  };

  const getSubMenuStyle = (item) => {
    if (pageName.toLowerCase() === item.toLowerCase()) return "text-primary";
    return "text-sidebar-base group-hover:text-sidebar-active";
  };

  useEffect(() => {
    // close the submenu if the sidebar is closed
    if (!sidebarActive) {
      setSubMenu(SUBMENU.DEFAULT);
    }

    // open the submenu if the sidebar is open and active item is present
    if (sidebarActive && activeItem > -1) {
      setTimeout(() => {
        setSubMenu(SUBMENU.OPERATIONS);
      }, 200);
    }
  }, [sidebarActive, setSubMenu, activeItem]);

  return (
    <div className="relative">
      <div
        role="button"
        className={`flex items-center mt-5 py-2 px-6 h-9 cursor-pointer group ${getContainerStyle()}`}
        onMouseEnter={() => {
          if (subMenu === SUBMENU.DEFAULT) {
            setHover(true);
          }
        }}
        onMouseLeave={() => setHover(false)}
        onClick={handleSubMenu}
      >
        <motion.div className="w-5 h-5">
          <OperationsIcon
            className={`group-hover:text-sidebar-active shrink-0 ${getHeaderMenuStyle()}`}
            fillColor={getHeaderIconStyle()}
          />
        </motion.div>

        {(sidebarActive || hover || subMenu === SUBMENU.OPERATIONS) && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className={`w-full ml-2 flex-1 font-aileron font-semibold text-xs group-hover:text-sidebar-active ${getHeaderMenuStyle()}`}
          >
            Operations
          </motion.p>
        )}

        {(sidebarActive || hover || subMenu === SUBMENU.OPERATIONS) && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="w-2.5 h-2.5"
          >
            <ChevronIcon
              strokeWidth="1.5"
              className={`w-2.5 h-2.5 group-hover:stroke-sidebar-active transform transition-all
              ${getHeaderMenuStyle()}
              ${subMenu === SUBMENU.OPERATIONS ? "-rotate-90" : "rotate-90"}
            `}
            />
          </motion.div>
        )}
      </div>

      <div
        className={`overflow-hidden ${getSubMenuContainerStyle()}`}
        style={{
          boxShadow:
            !sidebarActive && subMenu === SUBMENU.OPERATIONS
              ? "12px 12px 16px -4px #10182814"
              : "none",
        }}
      >
        {subMenu === SUBMENU.OPERATIONS &&
          items.map((i) => {
            const selected = pageName.toLowerCase() === i.label.toLowerCase();

            return (
              <div
                key={i.label}
                className={`flex items-center gap-x-2 px-[30px] py-3 cursor-pointer group 
                  ${selected && "bg-sidebar-active"}
                `}
                onClick={() => navigate(i.path)}
              >
                <span className={`w-4 h-4 ${getSubMenuStyle(i.label)}`}>
                  {i.icon}
                </span>
                <p
                  className={`font-aileron text-xs font-normal capitalize ${getSubMenuStyle(
                    i.label,
                  )}`}
                >
                  {i.label}
                </p>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default OperationItem;
